module.exports = __webpack_public_path__ + "img/prize-bg.eab7751.png";